import {SlInput} from '@shoelace-style/shoelace/shoelace';

export class LoginForm {
    // strippe leerzeichen aus den login inputs LOG41-1490
    constructor(viewRoot: HTMLElement) {
        const loginForm = viewRoot.querySelector('.login-form');

        if (loginForm) {
            var shoelaceInputs = loginForm.querySelectorAll<SlInput>('sl-input');
            if (shoelaceInputs.length > 0) {
                shoelaceInputs.forEach((shoelaceInput) => {
                    shoelaceInput.addEventListener('sl-change', () => {
                        shoelaceInput.value = shoelaceInput.value.replace(/\s+/g, '');
                    });
                });
            }
        }
    }
}
